import { isVisibleFieldVisibleProps } from 'utils/loan'

import { IOverviewStepTitleConfig } from '../RulesConfiguration/OverviewStepTitles'

export const borrowerPipelineAttentionTitleKeys: Record<string, string> = {
  signLoanApplication: 'Sign Loan Application',
  assetVerification: 'Asset Verification',
}

export type BorrowerPipelineAttentionTitleKey = 'signLoanApplication' | 'assetVerification'

export type TBorrowerPipelineAttentionTitlesConfig = Record<string, IOverviewStepTitleConfig>

export interface IPipelineAttentionItem {
  visible: boolean
  title: string
}

export type IPipelineAttentionByLoan = Record<
  number,
  Record<BorrowerPipelineAttentionTitleKey, IPipelineAttentionItem>
>

export const isBorrowerPipelineAttentionShown = (
  config: TBorrowerPipelineAttentionTitlesConfig | undefined | null,
  key: BorrowerPipelineAttentionTitleKey,
): boolean => {
  const cfg = config?.[key]
  if (!cfg) return true
  return cfg.show !== false
}

export const resolveBorrowerPipelineAttentionTitle = (
  config: TBorrowerPipelineAttentionTitlesConfig | undefined | null,
  key: BorrowerPipelineAttentionTitleKey,
  loan?: Record<string, any>,
): string => {
  const fallback = borrowerPipelineAttentionTitleKeys[key]
  const cfg = config?.[key]
  if (!cfg) return fallback

  if (Array.isArray(cfg.rules)) {
    for (const rule of cfg.rules) {
      if (!rule?.title) continue
      if (isVisibleFieldVisibleProps({ visibleLogic: rule.visibleLogic }, loan)) return rule.title
    }
  }

  const title = cfg.default?.trim()
  return title || fallback
}
